// extracted by mini-css-extract-plugin
export default {"HeaderSearchIcon":"style_HeaderSearchIcon__nMJEc"};